var exports = {
  "description": "xf0b3b88a--13abdd--description",
  "highlighted-word": "xf0b3b88a--13abdd--highlighted-word",
  "recidivist": "xf0b3b88a--13abdd--recidivist",
  "excluded-from-action": "xf0b3b88a--13abdd--excluded-from-action",
  "svg-container": "xf0b3b88a--13abdd--svg-container",
  "recidivist-description": "xf0b3b88a--13abdd--recidivist-description",
  "link": "xf0b3b88a--13abdd--link",
  "complaint": "xf0b3b88a--13abdd--complaint",
};

module.exports = exports;
